<template>
    <form class="form-details" @submit.prevent="nextPage()">
        <section class="controls-container">
            <button class="_approve" :disabled="formLoading">
                {{ formLoading ? 'Loading...' : 'Next' }}
            </button>
        </section>

        <section class="form-container">
            <h3 class="form-header">
                Account Details
            </h3>

            <section class="form-section">
                <InputField
                    class="input-box"
                    label="Company Name"
                    placeholder="Company Name"
                    :disable="accountDetailsLoading"
                    v-model="accountForm.company_name"
                    :required="true"
                />
            </section>

			<section class="form-section">
                <InputField
                    class="input-box"
                    label="Company Email"
                    placeholder="Company Email"
                    type="email"
                    :disable="accountDetailsLoading"
                    v-model="accountForm.email"
                    :required="true"
                />
            </section>

            <section class="form-section host-name">
                <span class="form-title">
                    <span class="required">*</span> Host Name
                </span>

                <section class="input-section">
                    <InputField
                        class="input-box"
                        placeholder="First Name"
                        :limit="50"
                        :disable="accountDetailsLoading"
                        v-model="accountForm.first_name"
                    />

                    <InputField
                        class="input-box"
                        placeholder="Last Name"
                        :limit="50"
                        :disable="accountDetailsLoading"
                        v-model="accountForm.last_name"
                    />
                </section>
            </section>

            <section class="form-section">
                <InputField
                    class="input-box"
                    label="Host Email"
                    placeholder="Host Email"
                    type="email"
                    :disable="accountDetailsLoading"
                    v-model="accountForm.company_email"
                />
            </section>

            <section class="form-section password">
                <section class="input-section">
                    <span class="form-title">
                        Password
                    </span>

                    <p class="desc">
                        Cannot be seen after ‘Save’
                    </p>
                    <button class="generate" @click.prevent="generatePass()" :disabled="loading">
                        Generate New Password
                    </button>
                </section>

                <section class="input-section">
                    <InputField
                        class="input-box"
                        label="New Password"
                        type="text"
                        :disable="true"
                        v-model="accountForm.password"
                        @click="copyPass()"
                    />
                </section>
            </section>

            <section class="form-section phone">
                <span class="form-title">
                    <span class="required">*</span> Contact Number
                </span>

                <section class="input-container">
                    <span class="country-code">
                        {{ accountForm.country_code.int_dialing  }}
                    </span>

                    <InputField
                        class="input-box"
                        placeholder="Phone"
                        type="number"
                        :limit="30"
                        :disable="accountDetailsLoading"
                        v-model="accountForm.contact_no"
                    />
                </section>
            </section>

            <section class="form-section phone">
                <span class="form-title">
                    Phone Number
                </span>

                <InputField
                    class="input-box"
                    placeholder="Phone"
                    type="number"
                    :limit="30"
                    :disable="accountDetailsLoading"
                    v-model="accountForm.phone_number"
                />
            </section>

			<section
				class="form-section host-name"
				v-if="storeModule !== 'distributor'"
			>
                <section class="input-section">
                    <InputField
                        class="input-box"
						label="Bldg/Apt Name"
                        :limit="50"
                        :disable="accountDetailsLoading"
                        v-model="accountForm.bldg_apt_name"
                        :required="true"
                    />

                    <InputField
                        class="input-box"
						label="Street"
                        :limit="50"
                        :disable="accountDetailsLoading"
                        v-model="accountForm.street"
                        :required="true"
                    />
                </section>
            </section>

			<section
				class="form-section"
				v-if="storeModule !== 'distributor'"
			>
                <InputField
                    class="input-box"
                    label="City"
                    v-model="accountForm.city"
                    :required="true"
                />
            </section>


            <section class="form-section">
                <SelectField
                    class="select-box"
                    label="Country"
                    placeholder="Country"
                    displayProp="name"
                    valueProp="name"
                    idProp="name"
                    :disable="countryLoading"
                    :items="countryList"
                    v-model="accountForm.country"
                    @input="getCountryZoneList($event)"
                    :required="true"
                />
            </section>

            <section class="form-section">
                <SelectField
                    class="select-box"
                    label="Zone Name"
                    placeholder="Zone Name"
                    displayProp="zone_name"
                    valueProp="zone_name"
                    idProp="zone_name"
                    :disable="disabledZoneName"
                    :items="countryZoneList"
                    v-model="accountForm.zone_name"
                    :required="true"
                />
            </section>

            <section class="form-section">
                <InputField
                    class="input-box"
                    label="ZIP Number"
                    placeholder="ZIP Number"
                    :limit="30"
                    :disable="accountDetailsLoading"
                    v-model="accountForm.zip_code"
                    :required="true"
                />
            </section>

            <section class="form-section password" v-if="!isUpdateAccount">
                <InputField
                    class="input-box"
                    label="Password"
                    placeholder="Password"
                    type="password"
                    :limit="100"
                    :autoComplete="false"
                    :togglePassword="true"
                    :disable="accountDetailsLoading"
                    v-model="accountForm.password"
                    :required="true"
                />
            </section>

            <section class="form-section password" v-if="!isUpdateAccount">
                <InputField
                    class="input-box"
                    label="Confirm Password"
                    placeholder="Confirm Password"
                    type="password"
                    :limit="100"
                    :autoComplete="false"
                    :togglePassword="true"
                    :disable="accountDetailsLoading"
                    v-model="accountForm.password_confirmation"
                    :required="true"
                />
            </section>

            <!-- <section class="form-section">
                <SelectField
                    class="select-box"
                    label="Company Type"
                    placeholder="Company Type"
                    displayProp="name"
                    valueProp="name"
                    idProp="name"
                    :disable="companyTypeLoading || accountDetailsLoading"
                    :items="companyTypeList"
                    v-model="accountForm.company_type"
                    v-if="storeModule === 'registeredAccount' || storeModule === 'accountRequest'"
                />
            </section> -->
        </section>
    </form>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import InputField from '@/components/utils/InputField'
import SelectField from '@/components/utils/SelectField'

export default {
    props: {
        storeModule: {
            type: String,
            default: '',
            required: true
        }
    },

    computed: {
        ...mapFields('accountForm', [
            'accountForm',
            'formLoading',
            'isUpdateAccount',
            'formPage',
            'isPageOneComplete'
        ]),

        ...mapFields('auth', [
			'loading'
        ]),

        ...mapFields('global', [
            'countryList',
            'countryLoading',

            'countryZoneList',
            'countryZoneLoading',

            'countryPartnerList',
            'countryPartnerLoading',

            'partnerList',
            'partnerLoading',

            'companyTypeList',
            'companyTypeLoading'
        ]),

        ...mapFields('accountOverview', [
            'accountDetails',
            'accountDetailsLoading'
        ]),

        disabledZoneName () {
            return this.countryZoneLoading || !Object.keys(this.accountForm.country).length || this.accountDetailsLoading
        }
    },

    methods: {
        async nextPage () {
            if (this.formLoading) return

            await this.$store.commit(`accountForm/isPageOneComplete`, this.storeModule)

            if (!this.isPageOneComplete) {
                await this.$store.commit('modal/toggleNotification', {
                    notificationName: 'notification-banner',
                    notificationType: 'warning',
                    notificationDesc: 'Please fill up all fields.',
                })

                return
            }

            // Check Email Validity
            if (this.accountDetails.email !== this.accountForm.email) {
                this.formLoading = true
                if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SERVER !== 'test') {
                    // const isEmailVerified = await this.$options.filters.verifyEmail(this.accountForm.email)
					const isEmailVerified = await this.$store.dispatch('auth/checkEmail', {email:this.accountForm.email})
        
                    if (!isEmailVerified) {
                        await this.$store.commit('modal/toggleNotification', {
                            notificationName: 'notification-banner',
                            notificationType: 'warning',
                            notificationDesc: 'Email is not valid',
                        })
        
                        this.formLoading = false
                        return
                    }
                }
            }

            this.formLoading = false
            this.formPage = 2
        },

        /* Form API Calls */
        getCountryZoneList ({ name, int_dialing }) {
            this.accountForm.country_code.int_dialing = int_dialing
            this.accountForm.zone_name = {}
            this.getCountryZone(name)
            this.getPartnerList(name)
        },

        getCountryZone (countryName) {
            this.$store.dispatch('global/getCountryZone', countryName)
        },

        getPartnerList (countryName) {
            this.$store.dispatch('global/getPartnerList', countryName)
        },

        async generatePass () {
            let res = await this.$store.dispatch('auth/generatePass')
            if (res) this.$set(this.accountForm, 'password', res)
        },

        async copyPass () {
            if (!this.accountForm.password) return
            try {
                await navigator.clipboard.writeText(this.accountForm.password)
                await this.$store.commit('modal/toggleNotification', {
                    notificationName: 'notification-banner',
                    notificationType: 'success',
                    notificationDesc: 'Password copied',
                })
            } catch (error) {
                console.error(error.message)
            }
        }
    },

    components: {
        InputField,
        SelectField
    },
}
</script>

<style lang="scss" scoped>
.form-details {
    width: 500px;
	margin-bottom: 150px;

    .controls-container {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;

        button {
            padding: 10px 15px;
        }
    }

    .form-container {
        background: #fff;
        box-shadow: 0px 0px 3px #2B3F5829;
        padding: 20px;
        border-radius: 3px;
        display: flex;
        flex-direction: column;

        .form-header {
            padding-bottom: 10px;
            border-bottom: 1px solid #E6EAF2;
            margin-bottom: 20px;
            margin-top: 0;
            color: #2B3F58;
            font-weight: 400;
        }

        .form-section {
            display: flex;
            align-items: center;

            .form-title {
                font-weight: 400;
                width: 150px;
                flex-shrink: 0;
                font-size: 15px;
                text-align: left;
                transition: 0.3s;
                color: #778395;
                font-size: 12px;

                span {
                    color: #BC3211;
                }
            }

            &.password {
                .input-section {
                    display: flex;
                    flex-direction: column;
                    flex: 1 1 auto;

                    &:first-child {
                        margin-right: 15px;
                    }

                    .form-title:hover {
                        color: unset;
                    }

                    .form-title {
                        margin: 10px 0;
                    }

                    .desc {
                        color: #647083;
                        font-style: italic;
                        font-size: 10px;
                        text-align: left;
                        margin-bottom: 10px;
                    }

                    /deep/ .input-box label {
                        padding: 10px 0 32px;
                    }
                }
                .generate {
                    background-color: #EBF8F6;
                    color: #2DC4B6;
                    padding: 10px 20px;
                }
            }

            &:hover {
                .form-title {
                    color: #2DC4B6;
                }
            }

            &.host-name {
                flex-direction: column;

                .form-title {
                    text-align: left;
                    display: block;
                    width: 100%;
                    padding: 10px 0;
                }

                &:hover {
                    .form-title {
                        color: #2DC4B6;
                    }

                    /deep/ .input-wrapper {
                        input {
                            border: 1px solid #2DC4B6;
                        }

                        label {
                            color: #2DC4B6;
                        }
                    }
                }

                .input-section {
                    display: flex;
                    width: 100%;

                    /deep/ .input-wrapper {
                        flex-direction: column;
                        flex: 1 1 auto;
                        width: auto;

                        &:first-child {
                            margin-right: 15px;
                        }

                        label {
                            padding-top: 0;
                        }
                    }
                }
            }

            &.subscription {
                &:hover {
                    .form-title {
                        color: #2DC4B6;
                    }

                    /deep/ .datepicker-box {
                        /deep/ .input-field {
                            border: 1px solid #2DC4B6;
                        }

                        label {
                            transition: 0.3s;
                            color: #2DC4B6;
                        }
                    }
                }

                .datepicker-section {
                    display: flex;
                    flex: 1 1 auto;

                    /deep/ .datepicker-box {
                        padding: 0;

                        &:first-child {
                            margin-right: 10px;
                        }

                        label {
                            height: auto;
                            padding: 0 0 10px 0;
                            font-weight: 600;
                        }
                    }
                }
            }

            &.phone {
                flex-direction: column;

                .form-title {
                    width: 100%;
                    margin-bottom: 10px;
                }

                .input-container {
                    display: flex;
                    justify-content: flex-start;
                    width: 100%;

                    .select-box {
                        width: 200px;
                        margin-right: 15px;
                        
                        /deep/ .selected-item {
                            padding: 9px 10px;
                            color: #778395;
                        }
                    }
        
                    .country-code {
                        border: 1px solid #C6C6C6;
                        border-radius: 4px;
                        font-size: 13px;
                        width: 170px;
                        margin-right: 15px;
                        height: 37px;
                        background: darken(#fff, 0.8%);
                        display: flex;
                        align-items: center;
                        padding-left: 10px;
                        user-select: none;
                    }
                }
            }

            &.assign-to {
                .form-title {
                    font-weight: 600;
                    width: 150px;
                    flex-shrink: 0;
                    font-size: 15px;
                    text-align: left;
                    transition: 0.3s;
                }

                .select-box {
                    &:not(:last-child) {
                        margin-right: 15px; 
                    }
                }
            }

            &:not(:last-child) {
                margin-bottom: 20px;
            }

            /deep/ .input-box, /deep/ .select-box {
                width: 100%;

                label {
                    font-weight: 400;
                    font-size: 12px;
                    flex-shrink: 0;
                    color: #778395;
                }

                .input-field {
                    flex: 1 1 auto;
                    color: #778395;
                }

                .toggle-password {
                    top: 41px;
                    right: 1px;
                    font-size: 13px;
                }
            }
        }
    }
}
</style>